import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "../../contexts/TranslationContext";
import "../../assets/css/galleryFilter.scss";
import api from "../../utils/api";
import { processScannersByAgency } from "../../utils/scannerProcessing";

import MultiSelection from "../UC/MultiSelection";

const EvidenceFilter = ({
    applyFilters,
    defaultFilters,
    onFilterChange,
    selectionMode = false,
    className = "",
    onFilterReady,
    resetFiltersTrigger,
}) => {
    const { language } = useTranslation();
    const [selectedScanners, setSelectedScanners] = useState([]);
    const [agencies, setAgencies] = useState([]);
    const [formattedScanners, setFormattedScanners] = useState([]);

    const loginAccount = useMemo(() => {
        const stored = localStorage.getItem("FWUser");
        return stored ? JSON.parse(stored) : null;
    }, []);

    // Evidence filters structure
    const [filters, setFilters] = useState({
        Scanner_IDs: [],
        Category_IDs: ["2", "3"], // Default to both types for evidence
        Agency_IDs: [],
        CaseIncidents: [],
        SearchFilterMode: "like",
    });

    const [inputCaseIncidents, setInputCaseIncidents] = useState("");

    useEffect(() => {
        if (onFilterChange) {
            onFilterChange(filters);
        }
    }, [filters, onFilterChange]);

    // Load Scanners from localStorage when component mounts
    useEffect(() => {
        // let storedScanners = localStorage.getItem("list_scanners");
        // if (storedScanners) {
        //     storedScanners = JSON.parse(storedScanners);

        //     // Process scanners to extract agencies
        //     const { agencies: extractedAgencies, formattedScanners } = processScannersByAgency(storedScanners);

        //     // Set default scanner selection based on login account
        //     if (loginAccount) {
        //         let loginAccountMatchID = `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}`;

        //         const defaultScanner = formattedScanners.find(scanner =>
        //             scanner.ID === loginAccountMatchID
        //         );

        //         if (defaultScanner) {
        //             setSelectedScanners([defaultScanner]);
        //             setFilters(prevFilters => ({
        //                 ...prevFilters,
        //                 Scanner_IDs: [defaultScanner.ID]
        //             }));
        //         } else {
        //             // default add current login account to formattedScanners and extractedAgencies
        //             if (loginAccount && loginAccount.Information) {
        //                 const newScanner = {
        //                     ID: `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}`,
        //                     Value: `${loginAccount.Information.Name}`,
        //                 }

        //                 // Add to agencies if not already present
        //                 if (!extractedAgencies.find(a => a.ID === loginAccount.Information.User_ID)) {
        //                     extractedAgencies.push({
        //                         ID: loginAccount.Information.User_ID,
        //                         Name: loginAccount.Information.Agency || loginAccount.Information.User_ID
        //                     });

        //                     formattedScanners.push({
        //                         ID: newScanner.ID,
        //                         Value: newScanner.Value,
        //                         GroupID: loginAccount.Information.User_ID
        //                     });
        //                 } else {
        //                     // Just add the scanner if agency exists
        //                     formattedScanners.push({
        //                         ID: newScanner.ID,
        //                         Value: newScanner.Value,
        //                         GroupID: loginAccount.Information.User_ID
        //                     });

        //                     // Set as default selected scanner
        //                     setSelectedScanners([{
        //                         ID: newScanner.ID,
        //                         Value: newScanner.Value,
        //                         GroupID: loginAccount.Information.User_ID
        //                     }]);
        //                     setFilters(prevFilters => ({
        //                         ...prevFilters,
        //                         Scanner_IDs: [newScanner.ID]
        //                     }));
        //                 }
        //             }
        //         } if (onFilterReady) {
        //             setTimeout(() => onFilterReady(true), 500);
        //         }
        //     }

        //     setAgencies(extractedAgencies);
        //     setFormattedScanners(formattedScanners);

        // } else {
        const fetchScannersFromAPI = async () => {
            try {
                // Loading state removed for simplicity

                if (onFilterReady)
                    onFilterReady(false);

                const _tokenRequestAPI = localStorage.getItem("FWToken");

                const response = await api.post(
                    `${global.config.api.domain}/fwiq-api/api/evidence/getpartialfilters`,
                    {
                        Token: _tokenRequestAPI,
                        Fields: ["agency", "scanner"]
                    }
                );

                if (response.status === 200 || response.status === 204) {
                    const data = response.data || {};
                    if (data.Scanners) {
                        localStorage.setItem("list_scanners", JSON.stringify(data.Scanners));
                    }

                    // Process scanners to extract agencies
                    const { agencies: extractedAgencies, formattedScanners } = processScannersByAgency(data.Scanners, data.Agencies);

                    // Set default scanner selection based on login account
                    if (loginAccount) {
                        let loginAccountMatchID = `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}`;

                        const defaultScanner = formattedScanners.find(scanner =>
                            scanner.ID === loginAccountMatchID
                        );

                        if (defaultScanner) {
                            setSelectedScanners([defaultScanner]);
                            
                            // Check if loginAccount is a customer and set Agency_IDs accordingly
                            const agencyIDs = [];
                            if (loginAccount.Information.AgencyType && 
                                loginAccount.Information.AgencyType.toLowerCase() === "customer") {
                                agencyIDs.push(loginAccount.Information.User_ID);
                            }
                            
                            setFilters(prevFilters => ({
                                ...prevFilters,
                                Scanner_IDs: [defaultScanner.ID],
                                Agency_IDs: agencyIDs
                            }));
                        } else {
                            // default add current login account to formattedScanners and extractedAgencies
                            if (loginAccount && loginAccount.Information) {
                                const newScanner = {
                                    ID: `${loginAccount.Information.User_ID}-${loginAccount.Information.User_ID_Ext}`,
                                    Value: `${loginAccount.Information.Name}`,
                                }

                                // Add to agencies if not already present
                                if (!extractedAgencies.find(a => a.ID === loginAccount.Information.User_ID)) {
                                    extractedAgencies.push({
                                        ID: loginAccount.Information.User_ID,
                                        Name: loginAccount.Information.AgencyName || loginAccount.Information.User_ID
                                    });

                                    formattedScanners.push({
                                        ID: newScanner.ID,
                                        Value: newScanner.Value,
                                        GroupID: loginAccount.Information.User_ID
                                    });
                                } else {
                                    // Just add the scanner if agency exists
                                    formattedScanners.push({
                                        ID: newScanner.ID,
                                        Value: newScanner.Value,
                                        GroupID: loginAccount.Information.User_ID
                                    });

                                    // Set as default selected scanner
                                    setSelectedScanners([{
                                        ID: newScanner.ID,
                                        Value: newScanner.Value,
                                        GroupID: loginAccount.Information.User_ID
                                    }]);
                                    
                                    // Check if loginAccount is a customer and set Agency_IDs accordingly
                                    const agencyIDs = [];
                                    if (loginAccount.Information.AgencyType && 
                                        loginAccount.Information.AgencyType.toLowerCase() === "customer") {
                                        agencyIDs.push(loginAccount.Information.User_ID);
                                    }
                                    
                                    setFilters(prevFilters => ({
                                        ...prevFilters,
                                        Scanner_IDs: [newScanner.ID],
                                        Agency_IDs: agencyIDs
                                    }));
                                }
                            }
                        }

                        if (onFilterReady) {
                            setTimeout(() => onFilterReady(true), 0);
                        }
                    }

                    setAgencies(extractedAgencies);
                    setFormattedScanners(formattedScanners);

                } else {
                    console.error("Failed to fetch scanners from API");
                    if (onFilterReady) {
                        onFilterReady(false);
                    }
                }
            } catch (error) {
                console.error("Error fetching scanners:", error);
                if (onFilterReady) {
                    onFilterReady(false);
                }
            } finally {
                // Loading state removed for simplicity
            }
        };
        fetchScannersFromAPI();
        //}
    }, [loginAccount, onFilterReady]);

    // Handle scanner selection changes
    const handleScannerChange = selectedOptions => {
        setSelectedScanners(selectedOptions);

        setFilters(prevFilters => ({
            ...prevFilters,
            Scanner_IDs: selectedOptions.map(option => option.ID)
        }));

        console.log("Selected Scanners:", selectedOptions.map(option => option.ID));
    };

    const handleApplyFilters = () => {

        console.log("Applying evidence filters:", filters);

        let formattedFilters = {
            CaseIncidents: filters.CaseIncidents,
            Category_IDs: filters.Category_IDs,
            Scanner_IDs: filters.Scanner_IDs,
            Agency_IDs: filters.Agency_IDs,
            SearchFilterMode: "like"
        };

        console.log("Formatted filters for API:", formattedFilters);

        // Call the applyFilters function passed from parent component
        applyFilters(formattedFilters);
    };

    useEffect(() => {
        // Reset filters when resetFiltersTrigger changes
        if (resetFiltersTrigger) {
            setFilters(defaultFilters);

            let defaultSelectedScanners = [];
            if (defaultFilters.Scanner_IDs && Array.isArray(defaultFilters.Scanner_IDs)) {
                defaultSelectedScanners = formattedScanners.filter(scanner =>
                    defaultFilters.Scanner_IDs.includes(scanner.ID)
                );
            }

            setSelectedScanners(defaultSelectedScanners);
            setInputCaseIncidents("");
        }
    }, [resetFiltersTrigger, defaultFilters, formattedScanners]);

    const caseIncidentChange = (value) => {
        // Split by comma, semicolon, and line breaks, then clean up
        setInputCaseIncidents(value);
        const caseIncidents = value.split(/[\n,;]+/).map(item => item.trim()).filter(item => item);
        setFilters(prevFilters => ({
            ...prevFilters,
            CaseIncidents: caseIncidents
        }));
    };



    return (
        <div className={`galleryFilter evidenceFilter${selectionMode ? " selectionMode" : ""}${className ? ` ${className}` : ""}`}>

            {/* Evidence-specific filters */}
            <div className="filters" data-type="evidence">
                {/* Scanner Selection with Grouping */}
                <div className="a-filter">
                    <div className="filter-title">{language.galleryFilter?.importedBy || "Imported By"}</div>
                    <div className="filter-data">
                        <MultiSelection
                            options={formattedScanners}
                            groups={agencies}
                            enableGroups={true}
                            placeholder={language.galleryFilter?.selectScanners || "Select Scanners"}
                            onChange={handleScannerChange}
                            enableSearch={true}
                            defaultSelected={selectedScanners}
                        />
                    </div>
                </div>

                {/* Data Type filter */}
                <div className="a-filter">
                    <div className="filter-title">{language.galleryFilter?.dataType || "Data Type"}</div>
                    <div className="filter-data checkbox-group">
                        <label>
                            <input
                                type="checkbox"
                                value="2"
                                checked={filters?.Category_IDs?.includes("2")}
                                onChange={e => {
                                    const value = e.target.value;
                                    setFilters(prevFilters => ({
                                        ...prevFilters,
                                        Category_IDs: e.target.checked
                                            ? [...(prevFilters.Category_IDs || []), value]
                                            : (prevFilters.Category_IDs || []).filter(type => type !== value)
                                    }));
                                }}
                            />
                            {language.galleryFilter?.recoveredImpression || "Recovered Impression (RS)"}
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                value="3"
                                checked={filters?.Category_IDs?.includes("3")}
                                onChange={e => {
                                    const value = e.target.value;
                                    setFilters(prevFilters => ({
                                        ...prevFilters,
                                        Category_IDs: e.target.checked
                                            ? [...(prevFilters.Category_IDs || []), value]
                                            : (prevFilters.Category_IDs || []).filter(type => type !== value)
                                    }));
                                }}
                            />
                            {language.galleryFilter?.testShoe || "Test Shoe (TS)"}
                        </label>
                    </div>
                </div>

                {/* Case/Incident Number filter */}
                <div className="a-filter">
                    <div className="filter-title">{language.galleryFilter?.caseIncident || "Case/Incident #"}</div>
                    <div className="filter-data">
                        <textarea
                            style={{ height: "6rem", resize: "none" }}
                            value={inputCaseIncidents}
                            onChange={e => caseIncidentChange(e.target.value)}
                            placeholder={language.galleryFilter?.enterCaseNumber || "Enter case incident(s), separated by commas, semicolons, or line breaks"}
                        />
                    </div>
                </div>
            </div>

            {/* Filter actions */}
            <div className="filter-actions">
                <button className="apply-filters-btn" onClick={handleApplyFilters}>
                    <i className="fa fa-filter" />
                    {language.galleryFilter?.applyFilters || "Apply Filters"}
                </button>
            </div>

        </div>
    );
};

export default EvidenceFilter;
